<script setup lang="ts">
import type { EnvelopeSubmitter } from '@/stores/useEnvelopeStore'

const props = defineProps<{ params: { data: { submitters: EnvelopeSubmitter[] } } }>()

const submitters = props.params.data.submitters || []

function statusIcon(status: string) {
  switch (status) {
    case 'COMPLETED':
      return '✓'
    case 'DECLINED':
      return '✗'
    case 'OPENED':
      return '👁'
    case 'SENT':
      return '✉'
    default:
      return '·'
  }
}

function statusColor(status: string) {
  switch (status) {
    case 'COMPLETED':
      return 'text-emerald-600'
    case 'DECLINED':
      return 'text-red-600'
    case 'OPENED':
      return 'text-blue-600'
    case 'SENT':
      return 'text-gray-600'
    default:
      return 'text-gray-400'
  }
}

function displayName(s: EnvelopeSubmitter) {
  if (s.contact) {
    const fn = s.contact.firstname || ''
    const ln = s.contact.lastname || ''
    const full = `${fn} ${ln}`.trim()
    if (full) return full
  }
  return s.name || s.email || 'Inconnu'
}
</script>

<template>
  <div class="flex flex-col gap-0.5 py-1 leading-tight">
    <div v-for="s in submitters" :key="s.uuid" class="flex items-center gap-1 text-sm">
      <span :class="statusColor(s.status)" class="font-bold w-4 text-center">{{ statusIcon(s.status) }}</span>
      <span :title="s.email || ''">{{ displayName(s) }}</span>
      <span v-if="!s.contactUuid" class="text-orange-500 text-xs" title="Contact non lié">⚠</span>
    </div>
    <div v-if="submitters.length === 0" class="text-gray-400 text-sm">-</div>
  </div>
</template>
